import { axios, getLoginURL } from 'ui/api/requestClient/editor';
import { axios as llmAxios } from 'ui/api/requestClient/llm';
import { axios as AgentAxios } from 'ui/api/requestClient/agent';

export { axios, llmAxios, AgentAxios, getLoginURL };
